import React from 'react'
import { Link } from 'react-router-dom'
import VideoModal from '../VideoModal'

import './Presentation.css'

const Presentation = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <div className={`wpo-about-area section-padding ${props.abClass}`}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-12 col-sm-12 image-container">

                        <div className='before-Image' >

                        </div>
                        <div className="wpo-about-img">
                            <img src={props.abimg} alt="" />
                        </div>
                        <div className="after-img">
                        </div>


                    </div>
                    <div className="col-lg-7 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-about-title">
                                <span>BULL</span>
                                <h3>Semat, Représentant officiel de BULL vous offre un panoplie de machines</h3>
                            </div>
                            <h5>La société SEMAT à été crée en 2008 avec la volonté d’une équipe jeune et avec une vision nouvelle du métier de concessionnaire de matériel BTP en Tunisie</h5>
                            <p>Solide, fiable, digne de confiance et travailleur. Chez Semat, nous savons que les machines que nous offrons sont une extension de vous. Nous sommes fiers de pouvoir vous offrir les meilleures machines. BULL est profondément ancré dans l'agriculture. Créer des machines pour aider les travailleurs les plus acharnés. De nombreuses années plus tard, nous proposons des produits dans le monde entier qui fonctionnent aussi dur que les personnes qui les possèdent et les exploitent. S'associer avec des agriculteurs, des travailleurs de la construction et des paysagistes - petits et grands - pour aider à déplacer des montagnes et à établir une solide base de confiance. Nous prenons soin de nos opérateurs. La sécurité et les commentaires des utilisateurs finaux façonnent chaque machine que nous construisons pour aider nos opérateurs à rentrer chez eux avec leurs proches (et, espérons-le, même un peu plus tôt que prévu).</p>
                            <div className="btns">
                                <Link to="/about" onClick={ClickHandler} className="theme-btn">Découvrir plus</Link>
                                <ul>
                                    <li className="video-holder">
                                        <VideoModal />
                                    </li>
                                    <li className="video-text">
                                        Regardez notre vidéo
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Presentation;